import React, { useState, useEffect } from 'react'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'
import { motion, AnimatePresence } from 'framer-motion'
import useAuthStore from '../../stores/authStore'
import Logo from '../common/Logo'

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true)
  const clearError = useAuthStore(state => state.clearError)
  const clearLogoutMessage = useAuthStore(state => state.clearLogoutMessage)
  const isSessionExpired = useAuthStore(state => state.isSessionExpired)
  const logoutMessage = useAuthStore(state => state.logoutMessage)

  // Clear any existing errors/messages when switching between login and register
  useEffect(() => {
    clearError()
    clearLogoutMessage()
  }, [isLogin, clearError, clearLogoutMessage])

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black flex items-center justify-center p-4 antialiased">
      <div className="w-full max-w-[400px] mx-auto">
        <div className="relative">
          <div className="flex flex-col items-center space-y-4 mb-8">
            <Logo size="lg" className="mb-2" />
            {/* <h1 className="text-2xl font-bold tracking-tight text-white">
              Welcome to PhotoWhim
            </h1> */}
            <p className="text-sm text-gray-400">
              {isLogin 
                ? 'Enter your credentials to access your account' 
                : 'Create an account to get started'}
            </p>
          </div>

          {isSessionExpired && (
            <div className="mb-6 rounded-lg bg-amber-500/10 px-3 py-2 text-sm text-amber-400 border border-amber-500/20">
              Your previous session has expired, please login again.
            </div>
          )}

          {logoutMessage && (
            <div className="mb-6 rounded-lg bg-green-500/10 px-3 py-2 text-sm text-green-400 border border-green-500/20">
              {logoutMessage}
            </div>
          )}

          <div className="bg-gray-800/50 backdrop-blur-xl rounded-xl border border-gray-700 shadow-2xl">
            <div className="p-6">
              <AnimatePresence mode="wait">
                <motion.div
                  key={isLogin ? 'login' : 'register'}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                >
                  {isLogin ? <LoginForm /> : <RegisterForm />}
                </motion.div>
              </AnimatePresence>

              <div className="mt-6 text-center">
                <button
                  onClick={() => setIsLogin(!isLogin)}
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  {isLogin 
                    ? "Don't have an account? Sign up" 
                    : "Already have an account? Sign in"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthPage